import {
  AiCameraIcon,
  CameraIcon,
  LinkIcon,
  PollIcon,
  PrivatePollIcon,
  VideoIcon,
} from 'components/CommonComponents/JSXIcons'
import QuestionIcon from 'components/CommonComponents/JSXIcons/QuestionIcon'
import keys from 'constants/keys'
import React from 'react'

interface IWidgetIcon {
  subtaskType: number
  /**
   * Photo subtasks under AI review carry the sparkle-badged camera instead of the plain one — the same
   * icon the creation row uses to add them, so the marker reads the same at creation and at execution.
   */
  isAiEnhanced?: boolean
}
export const WidgetIcon: React.FC<IWidgetIcon> = ({ subtaskType, isAiEnhanced = false }) => {
  const renderIcon = () => {
    switch (subtaskType) {
      case keys.SUBTASK_TYPES.POLL_SUBTASK:
        return (
          <PollIcon pos="absolute" left="50%" transform="translateX(-50%)" top="-25px" width="50px" height="50px" />
        )
      case keys.SUBTASK_TYPES.IMAGE_SUBTASK: {
        const Icon = isAiEnhanced ? AiCameraIcon : CameraIcon
        return <Icon pos="absolute" left="50%" transform="translateX(-50%)" top="-25px" width="50px" height="50px" />
      }
      case keys.SUBTASK_TYPES.VIDEO_SUBTASKS:
        return (
          <VideoIcon pos="absolute" left="50%" transform="translateX(-50%)" top="-25px" width="50px" height="50px" />
        )
      case keys.SUBTASK_TYPES.LINK_SUBTASK:
        return (
          <LinkIcon pos="absolute" left="50%" transform="translateX(-50%)" top="-25px" width="50px" height="50px" />
        )
      case keys.SUBTASK_TYPES.OPEN_QUESTION:
        return (
          <QuestionIcon pos="absolute" left="50%" transform="translateX(-50%)" top="-25px" width="50px" height="50px" />
        )
      case keys.SUBTASK_TYPES.PRIVATE_POLL:
        return (
          <PrivatePollIcon
            pos="absolute"
            left="50%"
            transform="translateX(-50%)"
            top="-25px"
            width="50px"
            height="50px"
          />
        )
      default:
        return null
    }
  }

  return <>{renderIcon()}</>
}
